import {Injectable} from "@angular/core";
import {RutasWebServices} from "../../services/rutasWebServices";
import {md5} from '../../services/md5';
import { HttpClient,HttpHeaders } from  '@angular/common/http';
import { tap, map, catchError } from "rxjs/operators";

@Injectable()
export class CrearNotasEnfermeriaService{
  
	constructor(private _http:HttpClient){}
	
	
	guardarNotaEnfermeria(data:any){
		//let dataUser=JSON.parse(sessionStorage.getItem('dataUser'));
		let params=data;
		let rutasWS = new RutasWebServices();
		//let headers = new Headers({"Content-type":"application/x-www-form-urlencoded"});		
		return this._http.post(rutasWS.urlWebService("GuardarNotaEnfermeria"),params).pipe(
			map(res => res),
			tap(res => {
				  
				},
				err => {
				  
				})
		  )
		//return this._http.post(rutasWS.urlWebService("SaveFormatoEvolucion"),params).map(res => res.json());
	}

	
 
}